import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import {MatDialogModule, MatIconModule} from '@angular/material';
import { NgxLoadingModule, } from 'ngx-loading';
import { BreedComponent } from '../breed/breed.component';

import { BreeddetailsComponent } from './breeddetails/breeddetails.component';
import { BreedmainComponent } from './breedmain/breedmain.component';
import { BreedRouting } from './breed.route';
import { SharedModule } from '../common/shared.module';




@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      NgbModule,
      NgxLoadingModule,
      RouterModule,
      BreedRouting,
        SharedModule,
        MatDialogModule,
        MatIconModule
    ],
    declarations: [
        BreedComponent,
        BreeddetailsComponent,
        BreedmainComponent
    ],
    })
    export class BreedModule { }
